export default __webpack_public_path__ + "locales/fi/Translations.json?hash=d1bc20c24d0867ca980ed77b817ecf64";